import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import Map from "@/components/Map"

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: Welcome
    }, {
      path: "/map",
      name: "map",
      component: Map,
      meta: {
        toolbar: false
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js